import type { RutaProd } from '../../../../runtime/rutas';

export default {
  ruta: '/sistema/Error',
  alias: ['/sistema/Error/Index'],
  documento: 'error',
  estado: 500,
  filas: [],
  cita: 'Controllers/ErrorController.cs:14-22; Web.config.example:90-105 (customErrors y httpErrors 500 → /Error)',
} satisfies RutaProd;
